// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Feature_wrap__1FXDi","message":"Feature_message__1vb0e"};